<template>
  <div class="tx-ktgdealersearch module-filter" :class="{ '-show-options': (showOptions && !mobile) }">
    <div class="filter__label" ref="link" @click="showOptions ? $emit('closeOptions') : $emit('openOptions')">
      <span>{{ label }}</span>
    </div>
    <div class="filter__options form" ref="container" v-show="showOptions || mobile">
      <div class="options__group" v-for="(group, groupIndex) in optionGroups" :key="groupIndex">
        <div class="group__title" v-if="optionGroups.length > 1 && group.title">
          <span>{{ group.title }}</span>
        </div>
        <div class="group__options" v-if="group.options && group.options.length">
          <div class="options__option" v-for="(option, optionIndex) in group.options.filter((item, index) => (!mobile || (mobile && index < 3) || (mobile && showAllOfGroups.includes(groupIndex))))" :key="optionIndex">
            <template v-if="option.ids && option.name && option.name.trim()">
              <div class="form-group">
                <div class="checkbox" :class="{ '-checked': value.filter(selected => selected === option.ids.toString()).length }">
                  <label :for="identifier + '-' + option.ids.toString()" class="form-check-label">
                    <input type="checkbox" :id="identifier + '-' + option.ids.toString()" :value="option.ids.toString()" v-model="value">
                    <span>{{ option.name }}</span>
                  </label>
                </div>
              </div>
            </template>
            <template v-if="option.id && option.description && option.description.trim()">
              <div class="form-group">
                <div class="checkbox" :class="{ '-checked': value.filter(selected => selected === option.id).length }">
                  <label :for="identifier + '-' + option.id" class="form-check-label">
                    <input type="checkbox" :id="identifier + '-' + option.id" :value="option.id" v-model="value">
                    <span>{{ option.description }}</span>
                  </label>
                </div>
              </div>
            </template>
          </div>
          <div class="options__show-all" v-if="mobile && group.options.length>= 3">
            <span @click.stop="showAllOfGroups = showAllOfGroups.filter(groupToShow => groupToShow !== groupIndex)" v-if="showAllOfGroups.includes(groupIndex)">{{ $t('filterBar.filters.showLess') }}</span>
            <span @click.stop="showAllOfGroups.push(groupIndex)" v-else>{{ $t('filterBar.filters.showMore') }}</span>
          </div>
        </div>
        <div class="group__options" v-if="group.fieldset && group.fieldset.length">
          <div class="options__fieldset" v-for="(fieldset, fieldsetIndex) in group.fieldset" :key="fieldsetIndex">
            <div class="fieldset__title" v-if="fieldset.title">
              <span>{{ fieldset.title }}</span>
            </div>
            <div class="options__option" v-for="(option, optionIndex) in fieldset.options.filter((item, index) => (!mobile || (mobile && index < 3) || (mobile && showAllOfGroups.includes(groupIndex))))" :key="optionIndex">
              <template v-if="option.ids && option.name && option.name.trim()">
                <div class="form-group">
                  <div class="checkbox" :class="{ '-checked': value.filter(selected => selected === option.ids.toString()).length }">
                    <label :for="identifier + '-' + option.ids.toString()" class="form-check-label">
                      <input type="checkbox" :id="identifier + '-' + option.ids.toString()" :value="option.ids.toString()" v-model="value">
                      <span>{{ option.name }}</span>
                    </label>
                  </div>
                </div>
              </template>
              <template v-if="option.id && option.description && option.description.trim()">
                <div class="form-group">
                  <div class="checkbox" :class="{ '-checked': value.filter(selected => selected === option.id).length }">
                    <label :for="identifier + '-' + option.id" class="form-check-label">
                      <input type="checkbox" :id="identifier + '-' + option.id" :value="option.id" v-model="value">
                      <span>{{ option.description }}</span>
                    </label>
                  </div>
                </div>
              </template>
            </div>
            <div class="options__show-all" v-if="mobile && fieldset.options.length>= 3">
              <span @click.stop="showAllOfGroups = showAllOfGroups.filter(groupToShow => groupToShow !== groupIndex)" v-if="showAllOfGroups.includes(groupIndex)">{{ $t('filterBar.filters.showLess') }}</span>
              <span @click.stop="showAllOfGroups.push(groupIndex)" v-else>{{ $t('filterBar.filters.showMore') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Filter',
  inject: ['mobile'],
  data () {
    return {
      showAllOfGroups: []
    }
  },
  props: {
    identifier: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    optionGroups: {
      type: Array,
      default: () => []
    },
    showOptions: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    value: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  created () {
    const self = this
    document.addEventListener('click', function (e) {
      if (self.showOptions && self.$refs.container && self.$refs.link !== e.target && !self.$refs.link.contains(e.target) && self.$refs.container !== e.target && !self.$refs.container.contains(e.target)) {
        self.$emit('closeOptions')
      }
    })
  }
}
</script>
